import React from 'react';
import { Button } from '@walmart-web/livingdesign-components';

import StatusCard from '../../../../components/StatusCard/index.tsx';
import GetSupportModal from './GetSupportModal/index.tsx';
import useModal from '../../../../hooks/useModal.ts';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '../../../../redux/hooks.ts';
import { ihutActions } from '../../../../redux/slices/ihut.ts';
import { logger } from '../../../../utils/logger.js';

type Props = {
  status: string;
};

const ProductDeliveryConfirmationCard: React.FC<Props> = ({ status }) => {
  const { t } = useTranslation('ihut');
  const dispatch = useAppDispatch();
  const { isOpen, openModal, closeModal } = useModal();

  const handleYesClick = () => {
    logger.clickStream('product_delivery_confirmation_yes_click', {
      panelistId: localStorage.getItem('panelistId') || ''
    });
    dispatch(ihutActions.setDeliveryConfirmed());
  };

  return (
    <>
      <StatusCard
        status={status}
        imgSrc="/assets/images/ihut/shipping.png"
        showTag
        tagProps={{
          variant: 'tertiary',
          color: 'spark',
          text: t('shippingInfo.pleaseConfirm')
        }}
      >
        <StatusCard.Heading>
          {t('shippingInfo.didYouGetProduct')}
        </StatusCard.Heading>
        <StatusCard.Row>
          <Button variant="secondary" size="small" onClick={openModal}>
            {t('no', { ns: 'common' })}
          </Button>
          <Button variant="primary" size="small" onClick={handleYesClick}>
            {t('yesGotIt', { ns: 'common' })}
          </Button>
        </StatusCard.Row>
      </StatusCard>
      <GetSupportModal isOpen={isOpen} handleClose={closeModal} />
    </>
  );
};

export default ProductDeliveryConfirmationCard;
